import NiceModal from "@ebay/nice-modal-react";
import "@fontsource-variable/inter/wght.css";
import "cropperjs/dist/cropper.css";

import CurrencyDisplay from "./components/CurrencyDisplay.tsx";
import AppContainer from "./components/AppContainer";
import Button from "./components/Button";
import Tabs from "./components/TabContainer";
import useApi, { type AccountProperties } from "./tests-api.ts";
import Spinner from "./components/Spinner.tsx";
import Modal from "./components/Modal.tsx";

import { useQuery, useQueryClient } from "@tanstack/preact-query";
import GachaDialog from "./GachaDialog.tsx";
import Catalog from "./Catalog.tsx";
import Editor from "./Editor.tsx";
import { useLayoutEffect } from "preact/hooks";
import TestApplet from "./TestApplet.tsx";

const App = () => {
    const queryClient = useQueryClient();
    const { data: accountDetails, isLoading: isLoadingAccDetails } = useQuery<AccountProperties>({
        queryKey: ["accountDetails"],
        queryFn: async () => {
            const api = await useApi();
            const giftReceived = await api.claimGift();
            if (giftReceived)
                NiceModal.show(Modal.Alert, {
                    title: "Вы получили 10 полихромов в подарок за открытие приложения сегодня.",
                });

            return api.getMyAccount();
        },
        refetchOnWindowFocus: false,
    });

    const buyKromer = async () => {
        await NiceModal.show(GachaDialog.GetKromer);
    };

    const gatekeepEditor = async (tab: string) => {
        if (tab != "editor") return true;

        if (accountDetails?.editor_activated) return true;

        return !!(await NiceModal.show(GachaDialog.EditorUnlockModal));
    };

    useLayoutEffect(() => {
        const referrer = new URL(document.referrer);
        const appLaunchParams = new URLSearchParams(referrer.search);

        if (appLaunchParams.has("test")) {
            Modal.useLoader("Загрузка теста", async () => {
                const test = await (
                    await useApi()
                ).getTest(appLaunchParams.get("test") as string, false, false, true);
                NiceModal.show(TestApplet, {
                    testPreview: test,
                    acquireFullTest: async () => {
                        try {
                            return await (await useApi()).getTest(test.id, false, true);
                        } finally {
                            await queryClient.invalidateQueries({ queryKey: ["accountDetails"] });
                        }
                    },
                });
            });
        }
    }, [accountDetails]);

    return (
        <AppContainer>
            <NiceModal.Provider>
                {!isLoadingAccDetails ? (
                    <Tabs.Container
                        tabs={[
                            { target: "gallery", label: "Каталог тестов" },
                            { target: "editor", label: "Редактор тестов" },
                        ]}
                        extras={
                            <>
                                Полихром:
                                <CurrencyDisplay amount={accountDetails!.kromer} />
                                &nbsp;
                                <Button label="Пополнить" kind="miniPrimary" onClick={buyKromer} />
                            </>
                        }
                        onTabChange={gatekeepEditor}
                    >
                        <Tabs.Content name="gallery">
                            <Catalog />
                        </Tabs.Content>
                        <Tabs.Content name="editor">
                            <Editor />
                        </Tabs.Content>
                    </Tabs.Container>
                ) : (
                    <Spinner.Loader label="Мини Тесты загружаются" fullHeight={true} />
                )}
            </NiceModal.Provider>
        </AppContainer>
    );
};

export default App;
